<div class="subscription-dialog" data-testid="sub-delete-container">

  <h1 ev-dialog-title>
    {{ languageService.languageJSON.SubscriptionsDialog_CancelSubscription }}
  </h1>
  <div ev-dialog-content>
    <div class="logo">
      <img src="assets/icons/dark/logo/ev_navigation_logo.png" alt="evnavigation" />
      @if (!type.includes('proplus.')) {
        <h2 data-testid="sub-delete-pro-title">PRO</h2>
      }
      @if (type.includes('proplus.')) {
        <img id="proplus-icon" data-testid="sub-delete-proplus-img" src="assets/icons/default/ui/pro_logo.svg" alt="plus" />
      }
    </div>

    <div class="content">
      <p data-testid="sub-delete-description-text" [innerHTML]="deleteSubscriptionDescription"></p>

            <p class="grey" data-testid="sub-delete-days-left-text" [innerHTML]="sorryToSeeYouLeaveMessage"></p>
        </div>

  </div>
  <div ev-dialog-actions>
    <button class="ev-button primary" mat-button data-testid="sub-delete-confirm-btn" (click)="delete()">{{
    languageService.languageJSON.Global_Delete }}</button>
    <button class="ev-button" mat-button data-testid="sub-delete-cancel-btn" (click)="close()">{{
    languageService.languageJSON.Global_Cancel }}</button>
  </div>

</div>